export default "__VITE_ASSET__d97SE9WS__"